import { Step, StepLabel, Stepper } from '@mui/material'
import * as React from 'react'
import { Box } from '@mui/system'
import PageSection from '../../../Constants&Theme/PageSection'

function NewScreenStepper({
  step,
  children,
  clone = false,
}: {
  step: number
  clone?: boolean
  children: any
}) {
  const createSteps = ['Create request', 'Add collections', 'Release']
  const cloneSteps = ['Clone request', 'Clone collections', 'Release']
  const steps = clone ? cloneSteps : createSteps
  return (
    <PageSection
      title={
        <Box sx={{ p: 2, width: 1, maxWidth: 'md' }}>
          <Stepper activeStep={step}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
      }
    >
      {children}
    </PageSection>
  )
}
export default NewScreenStepper
